/**
 * WordPress dependencies
 */
import '@safe-wordpress/dom-ready';
import '@safe-wordpress/notices';

import { render } from '@safe-wordpress/element';

/**
 * Internal dependencies
 */
import './style.scss';
import { WelcomeLayout } from './components/layout';

export function initPage( id: string ): void {
	const content = document.getElementById( id );
	render( <WelcomeLayout />, content );
}
